import React, { useEffect, useState } from "react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { TimesAreChanging } from "../components/landing/TimesAreChanging";
import { Benefits } from "../components/landing/Benefits";
import { OurEdge } from "../components/landing/OurEdge";
import { Philosophy } from "../components/landing/Philosophy";
import { AboutUs } from "../components/landing/AboutUs";
import { Testimonials } from "../components/landing/Testimonials";
import { FAQ } from "../components/landing/FAQ";
import { CTA } from "../components/landing/CTA";
import { Footer } from "../components/landing/Footer";
import { Modals } from "../components/landing/Modals";
import { ModalProvider, useModal } from "../lib/ModalContext";
import { useLenis } from "../lib/lenis";
import { fetchContent } from "../lib/api";
import { applySEO } from "../lib/image";
import { loadCaptcha } from "../lib/captcha";
import { consumePortalEtError } from "../components/landing/PortalLoginModal";

// Opens the portal-login modal automatically when WealthElite redirects back
// with an ?et=N error code in the URL.
const PortalEtErrorBridge = () => {
    const { open } = useModal();
    useEffect(() => {
        const msg = consumePortalEtError();
        if (msg) open("portal-login", { error: msg });
    }, [open]);
    return null;
};

export default function Landing() {
    useLenis();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let on = true;
        fetchContent()
            .then((c) => {
                if (on) {
                    setContent(c);
                    setLoading(false);
                    applySEO(c?.seo || {});
                    if (c?.integrations?.recaptcha_enabled) {
                        loadCaptcha(c?.integrations?.recaptcha_site_key);
                    }
                }
            })
            .catch(() => { if (on) setLoading(false); });
        return () => { on = false; };
        // Run once on mount — all referenced helpers (fetchContent, applySEO,
        // loadGA, loadCaptcha) are module-stable imports.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || !content) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="landing-loading">
                <div className="font-editorial italic text-oth-ink3">Quietly preparing…</div>
            </div>
        );
    }

    return (
        <ModalProvider>
            <PortalEtErrorBridge />
            <div className="relative" data-testid="landing-root">
                <div className="noise-layer" aria-hidden />
                <Navbar content={content} />
                <Hero content={content} />
                <AboutUs content={content} />
                <TimesAreChanging content={content} />
                <Benefits content={content} />
                <OurEdge content={content} />
                <Philosophy content={content} />
                <Testimonials content={content} />
                <FAQ content={content} />
                <CTA content={content} />
                <Footer content={content} />
                <Modals content={content} />
            </div>
        </ModalProvider>
    );
}
